"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), Object.defineProperty(exports, "key", {
  enumerable: !0,
  get: function get() {
    return _reactKey.key;
  }
}), Object.defineProperty(exports, "copy", {
  enumerable: !0,
  get: function get() {
    return _function.copy;
  }
}), Object.defineProperty(exports, "repeat", {
  enumerable: !0,
  get: function get() {
    return _function.repeat;
  }
}), Object.defineProperty(exports, "share", {
  enumerable: !0,
  get: function get() {
    return _share.share;
  }
}), Object.defineProperty(exports, "P", {
  enumerable: !0,
  get: function get() {
    return _share.P;
  }
}), exports.Passers = exports.PropPasser = exports.Prop = exports.reactCreateMap = exports.reactCloneMap = exports.reactCloneProp = exports.pass = void 0;

var _react = _interopRequireWildcard(require("react")),
    _reactKey = require("./reactKey/"),
    _function = require("./function"),
    _share = require("./share"),
    _api = require("./api");

function _interopRequireWildcard(a) {
  if (a && a.__esModule) return a;
  var b = {};
  if (null != a) for (var c in a) {
    if (Object.prototype.hasOwnProperty.call(a, c)) {
      var d = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(a, c) : {};
      d.get || d.set ? Object.defineProperty(b, c, d) : b[c] = a[c];
    }
  }
  return b["default"] = a, b;
}

function _objectSpread(a) {
  for (var b = 1; b < arguments.length; b++) {
    var c = null == arguments[b] ? {} : arguments[b],
        d = Object.keys(c);
    "function" == typeof Object.getOwnPropertySymbols && (d = d.concat(Object.getOwnPropertySymbols(c).filter(function (a) {
      return Object.getOwnPropertyDescriptor(c, a).enumerable;
    }))), d.forEach(function (b) {
      _defineProperty(a, b, c[b]);
    });
  }

  return a;
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

var map = _react.Children.map,
    pass = function pass() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : _react.Fragment;
  return function () {
    var b = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
    return function () {
      var c = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : [];
      return c.map(function (c) {
        var d = "li" === a ? _objectSpread({
          key: "p-".concat((0, _reactKey.key)(5)),
          style: {
            listStyle: "none"
          }
        }, b) : _objectSpread({}, b);
        return _react["default"].createElement(a, d, c);
      });
    };
  };
};

exports.pass = pass;

var reactCloneProp = function reactCloneProp() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
  return function () {
    var b = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {},
        c = !("" !== (0, _function.cutLeft)()((0, _api.classWriter)(a.props)(b))) || (0, _function.cutLeft)()((0, _api.classWriter)(a.props)(b));
    return (0, _react.cloneElement)(a, _objectSpread({}, b, (0, _api.propWriter)(a.props)(b), {
      className: c
    }, (0, _api.classReWriter)(b), (0, _api.classReWriter)(a.props)));
  };
};

exports.reactCloneProp = reactCloneProp;

var reactCloneMap = function reactCloneMap() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
  return function () {
    var b = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
    return map(a.children, function (a) {
      return reactCloneProp(a)(b);
    });
  };
};

exports.reactCloneMap = reactCloneMap;

var reactCreateMap = function reactCreateMap() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
  return function () {
    var b = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
    return function () {
      var c = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
      return function () {
        var d = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
        return map(a.children, function (a) {
          var e = "li" === d ? _objectSpread({
            key: "p-".concat((0, _reactKey.key)(5)),
            style: {
              listStyle: "none"
            }
          }, c) : _objectSpread({}, c);
          return (0, _react.createElement)(d, _objectSpread({}, e), reactCloneProp(a)(b));
        });
      };
    };
  };
};

exports.reactCreateMap = reactCreateMap;

var Prop = function Prop() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
  return function () {
    var b = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
    return _react["default"].createElement(_react.Fragment, null, reactCloneMap(b)(_objectSpread({}, a)));
  };
};

exports.Prop = Prop;

var PropPasser = function PropPasser() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
  return function () {
    var b = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
    return function () {
      var c = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : _react.Fragment;
      return function () {
        var d = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
        return (0, _react.createElement)(c, _objectSpread({}, b), reactCloneMap(d)(_objectSpread({}, a)));
      };
    };
  };
};

exports.PropPasser = PropPasser;

var Passers = function Passers() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
  return function () {
    var b = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
    return function () {
      var c = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : _react.Fragment;
      return function () {
        var d = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
        return reactCreateMap(d)(_objectSpread({}, a))(b)(c);
      };
    };
  };
};

exports.Passers = Passers;